import MotoristsFranchising from "./MotoristsFranchising";

export default MotoristsFranchising;
